// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"22ab224763875ae370a6","404":"3ca14a07f4a4482cd56f","406":"c28c35d183f2eda63a09"}[chunkId] + ".css";
};